/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
/**
 * GetAvailableLanguages Input Action
 */
export class GetAvailableCompanyTypeInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `availableCompanyTypes`;
    public getCacheObjectType = () => 'availableCompanyTypes';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetAvailableCompanyTypeData {
    key: string;
    value: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetAvailableCompanyTypeInput();
};

async function action(input: GetAvailableCompanyTypeInput, ctx: Msdyn365.IActionContext): Promise<IGetAvailableCompanyTypeData[]> {
    let result: any[] = [];
    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecGetAllCompanyTypes(languageId='${ctx.requestContext.locale}')`,
        'get',
        {},
        {
            headers: { OUN: ctx.requestContext.apiSettings.oun }
        }
    )
        .then(res => {
            result = (res?.data as any).value;
        })
        .catch(ex => {
            console.log('Error', ex);
        });

    const availableCompanyTypes = result.map((val: any) => {
        return { key: val.CompanyTypeCode, value: val.CompanyTypeDescription };
    });

    return availableCompanyTypes;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetAvailableCompanyTypeData[]>>action,
    id: 'GetAvailableCompanyTypes',
    input: createInput
});
